/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_PricingInputs */

const en_landing_footer_pricing = /** @type {(inputs: Landing_Footer_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

const id_landing_footer_pricing = /** @type {(inputs: Landing_Footer_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga`)
};

/**
* | output |
* | --- |
* | "Pricing" |
*
* @param {Landing_Footer_PricingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const landing_footer_pricing = /** @type {((inputs?: Landing_Footer_PricingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_PricingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_landing_footer_pricing(inputs)
	return en_landing_footer_pricing(inputs)
});